import React from "react";
import { Stack, Box } from "@mui/material";
import Chip, { ChipProps, ChipPropsColorOverrides } from "@mui/material/Chip";

import Typography from "@mui/material/Typography";

export type WcTagProps = ChipProps & {
  data: any;
  handleDelete?: any;
  controlDisabled?: boolean;
  deleteDisabled?: boolean;
  maxHeight?: any;
  label?: string;
  color?: ChipPropsColorOverrides;
};

export const WcTag = (props: WcTagProps) => {
  const {
    data,
    handleDelete,
    controlDisabled = false,
    deleteDisabled = false,
    maxHeight,
    label,
    size,
    sx,
    color,
  } = props;
  return (
    <Box id="WcTag">
      <Typography>{label}</Typography>
      <Stack direction="row" padding={0} gap={1}>
        <Chip
          label={data}
          disabled={controlDisabled}
          size={size}
          onDelete={
            !controlDisabled && !deleteDisabled
              ? () => handleDelete(data)
              : undefined
          }
          color={color ? color : "primary"}
          sx={[...(Array.isArray(sx) ? sx : [sx])]}
        />
      </Stack>
    </Box>
  );
};

export default WcTag;
